import React from 'react'
import logo from '../../../images/logo.webp'
import banner from '../../../images/radiance/radiance_banner.webp'
import radiance_1 from '../../../images/radiance/radiance1.webp'
import radiance_2 from '../../../images/radiance/radiance2.webp'
import radiance_3 from '../../../images/radiance/radiance3.webp'
import radiance_4 from '../../../images/radiance/radiance4.webp'
import radiance_5 from '../../../images/radiance/radiance5.webp'
import radiance_6 from '../../../images/radiance/radiance6.webp'
import radiance_7 from '../../../images/radiance/radiance7.webp'
import radiance_8 from '../../../images/radiance/radiance8.webp'
import radiance_9 from '../../../images/radiance/radiance9.webp'
import radiance_10 from '../../../images/radiance/radiance10.webp'
import radiance_11 from '../../../images/radiance/radiance11.webp'
import radiance_12 from '../../../images/radiance/radiance12.webp'
import radiance_13 from '../../../images/radiance/radiance13.webp'
import { FaSearch } from "react-icons/fa";
import { IoBag } from "react-icons/io5";
import { FaRegHeart } from "react-icons/fa";
import { FaUser } from "react-icons/fa";
import { FaBars } from "react-icons/fa6";
import { FaBell } from "react-icons/fa";
const Radiance = () => {
  return (
    
    <>


    <div className="bg-radiance_secondary py-2">
      <div className="container mx-auto grid grid-cols-2">
        <div className="text-lg font-semibold">Today's Metal Rate</div>
        <div className="flex justify-end items-center text-lg font-semibold">Plan Your Investment</div>
      </div>
    </div>
    
    
    <div className="container mx-auto flex items-center justify-between py-4">
      <div className="flex items-center">
        <img className="w-64 h-24" src={logo} alt="img" /> 
      </div>
    
      <div className="flex-1 px-4">
      <div className="relative flex items-center justify-center w-full">
      <input type="text" placeholder="Search..." className="border border-gray-300 rounded-lg p-4 pr-12 w-2/3"/>
        <FaSearch className="absolute right-40 mr-3 text-gray-400 bg-radiance_primary p-2 w-14 h-full rounded text-white" />
      </div>
    </div>
    
      <div className="flex items-center"> 
        <div className="flex flex-col items-center mr-4"> 
          <IoBag className="text-[25px]" /> 
          <span className="text-md font-semibold">Cart</span>
        </div>
    
        <div className="flex flex-col items-center mr-4"> 
          <FaRegHeart className="text-[25px]" /> 
          <span className="text-md font-semibold">Wishlist</span>
        </div>
    
        <div className="flex flex-col items-center"> 
          <FaUser className="text-[25px]" /> 
          <span className="text-md font-semibold">Login</span>
        </div>
      </div>
    </div>
    
    
    
    
    <div className="bg-radiance_secondary">
    <div class="container mx-auto text-md flex items-center space-x-8">
    <div class="flex items-center">
      <h1 class="bg-radiance_primary text-white px-4 py-2 rounded flex items-center"><FaBars class="mr-2"/>Categories</h1>
    </div>
    
        <ul class="list-none p-0 m-0 flex space-x-10 font-semibold">
            <li>Home</li>
            <li>About Us</li>
            <li>Contact Us</li>
            <li>Gold Plan</li>
        </ul>
    </div>
    </div>
    
    {/* End of Header Section */}
    
     
    
    <div className="">
        <img className="image" src={banner} alt="banner-image"></img>
    </div>
    
    {/* End of Banner Content */}
    
    <div className="flex justify-center text-2xl font-semibold my-7"> Shining Symbols of Elegance</div>

    <div className="container mx-auto grid grid-cols-2 gap-4">
  <div className="flex justify-center">
   <img className="image" src={radiance_1} alt="img"></img></div>
   <div className="flex justify-center">
   <img className="image" src={radiance_2} alt="img"></img></div>
   </div>
    
  
    
    {/* End of section1 */} 
    
    
    <div className="flex justify-center text-2xl font-semibold my-7">Ethereal Jewels for Every Occasion</div>
    
    <div className="container mx-auto grid grid-cols-3 gap-4">
  <div className="flex justify-center">
   <img className="image" src={radiance_3} alt="img"></img></div>
   <div className="flex justify-center">
   <img className="image" src={radiance_4} alt="img"></img></div>
   <div className="flex justify-center">
   <img className="image" src={radiance_5} alt="img"></img></div>
   </div>
    
    {/* End of section2 */} 
    
    
    <div className="flex justify-center text-2xl font-semibold my-7">Sparkle with Unmatched Grace</div>
    
    
   <div className="container mx-auto flex gap-4">
  
  <div className="w-1/4 flex justify-center ">
  <img className="image" src={radiance_6} alt="img"></img></div>
  <div className="w-1/4 flex justify-center">
  <img className="image" src={radiance_7} alt="img"></img>
  </div>
  <div className="w-2/4 flex justify-center">
  <img className="image" src={radiance_8} alt="img"></img>
  </div>
  </div>
  
    
         {/* End of section3 */}
    
    
    
         <div className="flex justify-center text-2xl font-semibold my-7">The Perfect Fusion of Art and Beauty</div>


         <div className=" container mx-auto ">
         <img className="image" src={radiance_9} alt="img"></img>
         </div> 
    
        
    
       {/* End of section4 */}
    
    
       <div className="flex justify-center text-2xl font-semibold my-7">Discover the Radiance of Silver Artistry</div>
    
    
    <div class="container mx-auto  flex gap-4">

    <div class=" w-1/3 flex justify-center ">
    <img className="image" src={radiance_10} alt="img"></img>
    </div>
  
  <div class="w-1/3 flex flex-col gap-4">
    <div class="h-1/2 flex justify-center">
    <img className="image" src={radiance_11} alt="img"></img>
    </div>
    <div class="h-1/2 flex justify-center">
    <img className="image" src={radiance_12} alt="img"></img>
    </div>
  </div>
  <div class="w-1/3 flex justify-center ">
  <img className="image" src={radiance_13} alt="img"></img>
  </div>
    </div>
    
    
                  {/* End of section5 */}
    
    <div className="bg-radiance_primary w-full mt-5">
      <div className="container mx-auto py-4">
        <div className="grid grid-cols-2 gap-8">
        <article className="text-white flex items-center space-x-4">
      <div className="flex items-center justify-center border border-slate-50 rounded-full bg-slate-50 w-10 h-10">
        <FaBell className="text-black" />
      </div>
      <div>
        <h3>SUBSCRIBE TO OUR NEWSLETTER</h3>
        <p>Get all the latest information on Events, Sales and Offers.</p>
      </div>
    </article>
    
    
          <form className="flex items-center">
            <input type="email" id="email" name="email" placeholder="Enter your email" className="w-full px-3 py-2 border rounded-lg mr-2"></input>
            <button type="submit" className="bg-radiance_secondary text-black font-semibold px-4 py-2 rounded-lg">
              <span>SUBSCRIBE</span>
            </button>
          </form>
        </div>
      </div> 
      
    </div>
    <div className="bg-radiance_secondary grid grid-cols-3 gap-4 ">
      <div className="flex justify-center">
    <img className="image w-64 h-24  " src={logo} alt="img"></img>
    </div>
    
    <div>
      <h2 className="my-4 text-black font-semibold">GET US HELP YOU</h2>
    <ul className="list-none p-0 m-0">
        <li className="py-2 ">Contact Us</li>
        <li className="py-2">Terms and Condition</li>
        <li className="py-2">FAQ</li>
    </ul>
    </div>
    
    <div>
      <h2 className="my-4 text-black font-semibold">OUR POLICIES</h2>
    <ul className="list-none p-0 m-0 ">
    <li className="py-2 ">Privacy Policy</li>
        <li className="py-2">Shipping Policy</li>
        <li className="py-2 ">Cancellation Policy</li>
        <li className="py-2 ">Exchange Policy</li>
    
    </ul>
    </div>
    
    </div>
    
    <div className=" bg-radiance_primary ">
      <div className="container mx-auto text-white">ⓒ All rights reserved</div>
    </div>
    
    {/* End of footer section */}
    </>
  )
}

export default Radiance;
